import { useMemo } from "react";
import { useRole } from "../../context/RoleContext";
import { ROLES } from "../../services/navigation";

/** Grafana is reverse-proxied behind the PMS origin at /monitoring. */
export default function MonitoringPage() {
  const { roleKeys } = useRole();
  const isITAdmin = roleKeys.includes(ROLES.IT_ADMIN);
  const grafanaUrl = useMemo(() => {
    const configured = process.env.REACT_APP_MONITORING_URL;
    const target = configured || `${window.location.origin}/monitoring/${isITAdmin ? "" : "dashboards"}`;
    if (isITAdmin || target.includes("kiosk")) return target;
    return `${target}${target.includes("?") ? "&" : "?"}kiosk`;
  }, [isITAdmin]);

  return (
    <section className="page monitoring-page" aria-labelledby="monitoring-title">
      <div className="page-header">
        <div>
          <h1 id="monitoring-title">Monitoring</h1>
          <p>{isITAdmin ? "Metrics, logs, traces, and audit monitoring." : "Application monitoring dashboards."}</p>
        </div>
        <a className="button button-secondary" href={grafanaUrl} target="_blank" rel="noreferrer">
          Open in new tab
        </a>
      </div>
      <div className="monitoring-frame-wrap">
        <iframe
          title="PMS monitoring dashboards"
          src={grafanaUrl}
          className="monitoring-frame"
          loading="lazy"
        />
      </div>
    </section>
  );
}
